/* tslint:disable */

/* eslint-disable */

/**
 * Title
 * Title
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';

/**
 *
 * @export
 * @interface Event
 */
export interface Event {
    [key: string]: object | any;
    /**
     *
     * @type {string}
     * @memberof Event
     */
    type?: string;
    /**
     *
     * @type {string}
     * @memberof Event
     */
    event: string;
    /**
     *
     * @type {number}
     * @memberof Event
     */
    timestamp?: number;
    /**
     *
     * @type {Date}
     * @memberof Event
     */
    dateTime?: Date;
    /**
     *
     * @type {object}
     * @memberof Event
     */
    context?: object;
}

export function EventFromJSON(json: any): Event {
    return EventFromJSONTyped(json, false);
}

export function EventFromJSONTyped(json: any, ignoreDiscriminator: boolean): Event {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        ...json,
        type: !exists(json, '_type') ? undefined : json['_type'],
        event: json['event'],
        timestamp: !exists(json, 'timestamp') ? undefined : json['timestamp'],
        dateTime: !exists(json, 'dateTime') ? undefined : new Date(json['dateTime']),
        context: !exists(json, 'context') ? undefined : json['context'],
    };
}

export function EventToJSON(value?: Event | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...value,
        _type: value.type,
        event: value.event,
        timestamp: value.timestamp,
        dateTime: value.dateTime === undefined ? undefined : value.dateTime.toISOString(),
        context: value.context,
    };
}
